// src/components/PasswordModal.js - Giao diện Đổi mật khẩu hiện đại & chuẩn hóa UI
import React, { useState } from 'react';
import { changePassword } from '../FirebaseService';
import NotificationPopup from './NotificationPopup';
import './PasswordModal.css';

const PasswordModal = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setNotification({
        show: true,
        message: 'Mật khẩu mới và xác nhận mật khẩu không khớp!',
        type: 'error',
      });
      return;
    }

    if (newPassword.length < 6) {
      setNotification({
        show: true,
        message: 'Mật khẩu mới phải có ít nhất 6 ký tự!',
        type: 'error',
      });
      return;
    }

    setIsSubmitting(true);
    setNotification({
      show: true,
      message: 'Đang xử lý đổi mật khẩu...',
      type: 'loading',
    });

    try {
      const result = await changePassword(currentPassword, newPassword);
      if (result.success) {
        setNotification({
          show: true,
          message: result.message || 'Đổi mật khẩu thành công!',
          type: 'success',
        });

        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');

        setTimeout(() => {
          onClose();
          setNotification({ show: false, message: '', type: '' });
        }, 1800);
      } else {
        setNotification({
          show: true,
          message: result.message || 'Lỗi khi đổi mật khẩu.',
          type: 'error',
        });
      }
    } catch (error) {
      setNotification({
        show: true,
        message: error.message || 'Có lỗi xảy ra khi đổi mật khẩu.',
        type: 'error',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="pwm-modal-overlay">
      <div className="pwm-modal-card">
        {/* HEADER */}
        <div className="pwm-modal-header">
          <div className="pwm-header-title">
            <span className="pwm-header-icon">🔒</span>
            <h3>Đổi Mật Khẩu</h3>
          </div>
          <button onClick={onClose} className="pwm-close-btn" title="Đóng">
            ✕
          </button>
        </div>

        {/* FORM NHẬP */}
        <form onSubmit={handlePasswordChange} className="pwm-form">
          {/* Mật khẩu hiện tại */}
          <div className="pwm-form-group">
            <label>Mật khẩu hiện tại (*):</label>
            <div className="pwm-input-wrapper">
              <input
                type={showCurrentPassword ? 'text' : 'password'}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                placeholder="Nhập mật khẩu đang sử dụng..."
                className="pwm-input"
              />
              <button
                type="button"
                className="pwm-eye-btn"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                tabIndex="-1"
              >
                {showCurrentPassword ? '👁️' : '🙈'}
              </button>
            </div>
          </div>

          {/* Mật khẩu mới */}
          <div className="pwm-form-group">
            <label>Mật khẩu mới (*):</label>
            <div className="pwm-input-wrapper">
              <input
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                placeholder="Tối thiểu 6 ký tự..."
                className="pwm-input"
              />
              <button
                type="button"
                className="pwm-eye-btn"
                onClick={() => setShowNewPassword(!showNewPassword)}
                tabIndex="-1"
              >
                {showNewPassword ? '👁️' : '🙈'}
              </button>
            </div>
          </div>

          {/* Xác nhận mật khẩu mới */}
          <div className="pwm-form-group">
            <label>Xác nhận mật khẩu mới (*):</label>
            <div className="pwm-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Nhập lại mật khẩu mới..."
                className="pwm-input"
              />
              <button
                type="button"
                className="pwm-eye-btn"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                tabIndex="-1"
              >
                {showConfirmPassword ? '👁️' : '🙈'}
              </button>
            </div>
          </div>

          {/* FOOTER NÚT BẤM */}
          <div className="pwm-modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="pwm-btn-cancel"
              disabled={isSubmitting}
            >
              Hủy Bỏ
            </button>
            <button
              type="submit"
              className="pwm-btn-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? '⏳ Đang lưu...' : 'Lưu Thay Đổi'}
            </button>
          </div>
        </form>
      </div>

      <NotificationPopup
        message={notification.message}
        type={notification.type}
        isVisible={notification.show}
      />
    </div>
  );
};

export default PasswordModal;